var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 804,
    height: 248,
    viewBox: "0 0 804 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05887 0 18 0H266C275.941 0 284 8.05887 284 18V57.8039C284 68.8496 275.046 77.8039 264 77.8039H252.605C235.15 77.8039 221 91.9539 221 109.409C221 119.676 212.676 128 202.409 128H18C8.05887 128 0 119.941 0 110V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 108,
    r: 25,
    fill: "#151521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.111 119.635H256.022M237.888 119.635H249.977M253 116.606V112.063",
    stroke: "#FFB7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.999 122.664C254.668 122.664 256.021 121.308 256.021 119.635C256.021 117.962 254.668 116.606 252.999 116.606C251.329 116.606 249.976 117.962 249.976 119.635C249.976 121.308 251.329 122.664 252.999 122.664Z",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.422 102.977C241.219 102.977 240.066 103.456 239.216 104.308C238.366 105.16 237.888 106.315 237.888 107.52C237.888 108.725 238.366 109.881 239.216 110.733C240.066 111.585 241.219 112.063 242.422 112.063H263.577C264.173 112.063 264.762 111.946 265.312 111.717C265.862 111.489 266.362 111.154 266.783 110.733C267.204 110.311 267.538 109.81 267.766 109.259C267.993 108.707 268.111 108.117 268.111 107.52C268.111 106.923 267.993 106.333 267.766 105.781C267.538 105.23 267.204 104.729 266.783 104.308C266.362 103.886 265.862 103.551 265.312 103.323C264.762 103.094 264.173 102.977 263.577 102.977M242.422 102.977H263.577M242.422 102.977C241.219 102.977 240.066 102.498 239.216 101.646C238.366 100.794 237.888 99.6388 237.888 98.4339C237.888 97.2289 238.366 96.0734 239.216 95.2214C240.066 94.3694 241.219 93.8907 242.422 93.8907H263.577C264.78 93.8907 265.933 94.3694 266.783 95.2214C267.633 96.0734 268.111 97.2289 268.111 98.4339C268.111 99.6388 267.633 100.794 266.783 101.646C265.933 102.498 264.78 102.977 263.577 102.977",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.511 98.434H263.578M254.511 107.52H263.578",
    stroke: "#FFB7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.694 98.4339C244.694 98.8576 244.352 99.1983 243.933 99.1983C243.514 99.1983 243.172 98.8576 243.172 98.4339C243.172 98.0103 243.514 97.6696 243.933 97.6696C244.352 97.6696 244.694 98.0103 244.694 98.4339Z",
    fill: "white",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.694 107.52C244.694 107.944 244.352 108.284 243.933 108.284C243.514 108.284 243.172 107.944 243.172 107.52C243.172 107.096 243.514 106.756 243.933 106.756C244.352 106.756 244.694 107.096 244.694 107.52Z",
    fill: "white",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M285.494 97C285.494 86.5066 294 78 304.494 78H784C794.493 78 803 86.5066 803 97V228C803 238.493 794.493 247 784 247H244C233.507 247 225 238.493 225 228V160C225 149.507 233.507 141 244 141H250.494C269.824 141 285.494 125.33 285.494 106V97Z",
    stroke: "#FFB7D7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.2cd159857a8e8ae77fcaa4fab6963341.svg";
export { ForwardRef as ReactComponent };